export default "__VITE_ASSET__dc4fa612__"